import * as Sentry from '@sentry/browser'
import { agentV2Request } from '@/agent-v2/conversations/fetch/agent-v2-request'
import { AgentV2TurnFeedback, AgentV2TurnFeedbackSchema } from '@/agent-v2/feedback/schemas'
import { FeedbackThumb } from '@/chat-common/schemas/feedback-schema'
import { kAgentV2RouterApiBasePath } from '@/constants/constants-api-paths'
import { kPaxtonAppApiRESTBaseUrl } from '@/constants/constants-links'
import { getResponseDebugContext, getTopLevelKeys } from '@/util/api/response-body'
import { ApiResponsePayloadError } from '@/util/errors/api-response-payload-error'

type PutAgentV2TurnFeedbackArgs = {
  turnId: string
  thumb: FeedbackThumb
  thumbText: string | null
  thumbReasons: string[] | null
}

export async function putAgentV2TurnFeedback(args: PutAgentV2TurnFeedbackArgs): Promise<AgentV2TurnFeedback> {
  const url = `${kPaxtonAppApiRESTBaseUrl()}${kAgentV2RouterApiBasePath}/turns/${encodeURIComponent(args.turnId)}/feedback`
  return agentV2Request({
    url,
    method: 'PUT',
    sentryEndpoint: 'PUT /api/v2/agent/turns/{turn_id}/feedback',
    sentryExtra: { turnId: args.turnId },
    body: JSON.stringify({
      thumb: args.thumb,
      thumb_text: args.thumbText,
      thumb_reasons: args.thumbReasons,
    }),
    parseResponse: (data, { response, sentryTags }) => {
      const parsed = AgentV2TurnFeedbackSchema.safeParse(data)
      if (parsed.success) return parsed.data

      Sentry.withScope((scope) => {
        scope.setTags(sentryTags)
        Sentry.captureException(new Error('Agent v2 feedback response schema validation failed'), {
          extra: {
            ...getResponseDebugContext(response, url),
            turnId: args.turnId,
            responseKeys: getTopLevelKeys(data),
            issues: parsed.error.issues,
          },
        })
      })

      throw new ApiResponsePayloadError(response.status, 'Invalid Agent v2 feedback response shape', parsed.error.issues)
    },
  })
}
